import {Component, Vue} from "vue-property-decorator";
import {Message, Subscription} from "webstomp-client";
import StartupProgressUpdate from "./model/StartupProgressUpdate";
import {EVENTBUS_TOPICS, STOMP_TOPICS} from "@/lib/constants";
import {EventBus} from "@/lib/event-bus";


@Component
export default class StartupModal extends Vue {

    public startupProgressSub!: Subscription;
    public startupModalVisible: boolean = false;
    public startupProgressPercentage: number = -1;
    public startupProgressText: string = "global.startup.loading";
    public startupProgressParamValues: string[] = [];

    public mounted() {
        EventBus.$on(EVENTBUS_TOPICS.WEBSOCKET_CONNECTED, this.websocketConnected);
        this.websocketConnected(this.$store.state.stompClient.connected);
    }

    public websocketConnected(state: boolean) {
        if (state) {
            this.startupProgressSub = this.$store.state.stompClient.subscribe(
                STOMP_TOPICS.STARTUP_PROGRESS,
                (message: Message) => {
                    const progressUpdate: StartupProgressUpdate = JSON.parse(message.body);
                    this.handleStartupProgressUpdate(progressUpdate);
                }
            );
        } else {
            // Show startup modal without percentage, to indicate backend connection is lost
            this.startupModalVisible = true;
            this.startupProgressPercentage = -1;
        }
    }

    public beforeDestroy() {
        EventBus.$off(EVENTBUS_TOPICS.WEBSOCKET_CONNECTED, this.websocketConnected);

        if (this.startupProgressSub !== undefined) {
            this.startupProgressSub.unsubscribe();
        }
    }

    public handleStartupProgressUpdate(update: StartupProgressUpdate) {
        // If percentage <0, we only update the progress text
        if (update.percentage > -1) {
            this.startupProgressPercentage = update.percentage;
        }

        this.startupProgressText = update.message;
        this.startupProgressParamValues = update.paramValues;

        if (
            this.startupProgressPercentage > -1 &&
            this.startupProgressPercentage < 100
        ) {
            this.startupModalVisible = true;
        } else if (this.startupProgressPercentage === 100) {
            // We want to display the 100% filled bar for half a second (just because it looks better)
            setTimeout(() => {
                this.startupModalVisible = false;
                this.startupProgressPercentage = -1;
            }, 500);
        }
    }
}
